import type * as React from 'react';
import { put } from '@Domain/Api';
import type { DocumentTypePayload } from '@Application/Documents/DocumentTypes/Actions/documentTypesFetched';
import documentTypeRenamed, {
	type DocumentTypeRenamedAction,
} from '@Application/Documents/DocumentTypes/Actions/documentTypeRenamed';
import documentTypeRenamingFailed, {
	type DocumentTypeRenamingFailedAction,
} from '@Application/Documents/DocumentTypes/Actions/documentTypeRenamingFailed';
import type RenameDocumentType from '@Application/Documents/DocumentTypes/Commands/RenameDocumentType';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = DocumentTypeRenamedAction | DocumentTypeRenamingFailedAction;

export default (command: RenameDocumentType) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<DocumentTypePayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/document-types/${command.documentTypeId}`,
				command.toJSON(),
			);

			const action = documentTypeRenamed(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTypeRenamingFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
